/* ============================================================
   BLURRD CRO build, Sept 2026. Loaded (defer) from layout/theme.liquid.
   PDP module (re-runs whenever the Concept theme swaps the product section, e.g. Style swatch switch):
     A. Size must be chosen before Add to Cart / wallets (no pre-selected size)
     B. Hand step copy: which hand, with plain-English helper and sub-labels (always visible)
     C. Sold out: hide the theme's dead button when Klaviyo's back-in-stock button is present
     D. Ships-by date under Add to Cart (America/New_York, 1pm cutoff, skips weekends)
     E. MutationObserver: re-applies A, B, C after the theme re-renders the variant picker
     F. Mobile: title, rating and price above the gallery
     G. Style swatches first
     H. Swipe arrows on the gallery and thumbnail row (touch widths)
   Cart module: compact "Complete the set" rows with colour / size / hand pickers and one-tap add.
   Nothing here changes prices, variants, or cart contents on its own.
   ============================================================ */
(function () {
  'use strict';
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var S = { info: null, form: null, formId: null, pending: false, gateEnabled: false, originalLabels: [], mo: null, hasSize: false };

  function sizeFieldset() {
    return $('.variant-picker fieldset[data-option-slug="size"]') || $('.variant-picker fieldset[data-option-slug="accessory-size"]');
  }
  function handFieldset() {
    return $('.variant-picker fieldset[data-option-slug="hand"]') || $('.variant-picker fieldset[data-option-slug="glove-hand"]');
  }
  function addButtons() {
    var btns = S.formId ? $$('button[name="add"][form="' + S.formId + '"]') : [];
    if (!btns.length && S.form) btns = $$('button.product-form__submit', S.form);
    if (!btns.length) btns = $$('button[name="add"]');
    return btns;
  }
  function labelSpan(btn) {
    return btn.querySelector('.btn-text > span:first-child') || btn.querySelector('.btn-text');
  }

  /* ---------- A. Size gate ---------- */
  function setPending(on) {
    S.pending = on;
    document.body.classList.toggle('cro-size-pending', on);
    addButtons().forEach(function (btn, i) {
      var span = labelSpan(btn);
      if (!span) return;
      if (on) {
        if (S.originalLabels[i] === undefined) S.originalLabels[i] = span.textContent;
        if (span.textContent !== 'Select a size') span.textContent = 'Select a size';
      } else if (S.originalLabels[i] !== undefined) {
        span.textContent = S.originalLabels[i];
      }
    });
    var sizeFs = sizeFieldset();
    if (sizeFs && on) {
      var current = sizeFs.querySelector('.form__label .font-medium');
      if (current && current.textContent !== 'Choose') current.textContent = 'Choose';
    }
  }

  function showSizeError() {
    var sizeFs = sizeFieldset();
    if (!sizeFs) return;
    var err = sizeFs.querySelector('.cro-size-error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'cro-size-error';
      err.textContent = 'Pick your size first. Not sure? Open the size guide above.';
      sizeFs.appendChild(err);
    }
    sizeFs.classList.remove('cro-nudge'); void sizeFs.offsetWidth; sizeFs.classList.add('cro-nudge');
    var top = sizeFs.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  // Idempotent: puts the gate onto whatever size fieldset is currently in the DOM.
  function applySizeGate() {
    if (!S.gateEnabled || !S.pending) return;
    var sizeFs = sizeFieldset();
    if (!sizeFs) return;
    if (!sizeFs.classList.contains('cro-size-gate')) sizeFs.classList.add('cro-size-gate');
    if (!sizeFs.querySelector('.cro-size-hint')) {
      var hint = document.createElement('p');
      hint.className = 'cro-size-hint';
      hint.textContent = 'Choose a size to continue. Cabretta runs snug at first and molds to your hand in 2 to 3 rounds.';
      sizeFs.appendChild(hint);
    }
    $$('input[type="radio"]', sizeFs).forEach(function (r) { if (r.checked) r.checked = false; });
    setPending(true);
  }

  function sizeChosen() {
    var sizeFs = sizeFieldset();
    var err = sizeFs && sizeFs.querySelector('.cro-size-error'); if (err) err.remove();
    setPending(false);
  }

  // Document-level listeners, registered once. They read the current state, so they survive section swaps.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!S.pending || !t || t.type !== 'radio' || !t.checked) return;
    var sizeFs = sizeFieldset();
    if (!sizeFs || !sizeFs.contains(t)) return;
    sizeChosen();
  }, true);
  document.addEventListener('click', function (e) {
    if (!S.pending || !e.target.closest) return;
    var sizeFs = sizeFieldset();
    if (!sizeFs) return;
    var lab = e.target.closest('label');
    var input = lab && lab.htmlFor ? document.getElementById(lab.htmlFor) : (e.target.type === 'radio' ? e.target : null);
    if (!input || !sizeFs.contains(input) || input.disabled) return;
    sizeChosen();
  }, true);
  // Block Add to Cart, sticky bar button, wallet buttons (events from their shadow DOM retarget to the host) and the case upsell while a size is not chosen.
  document.addEventListener('click', function (e) {
    if (!S.pending || !e.target.closest) return;
    var b = e.target.closest('button[name="add"]') || e.target.closest('.shopify-payment-button') || e.target.closest('#blurrd-case-addbtn');
    if (!b) return;
    e.preventDefault(); e.stopImmediatePropagation();
    showSizeError();
  }, true);
  document.addEventListener('submit', function (e) {
    if (!S.pending || !S.form || e.target !== S.form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    showSizeError();
  }, true);

  /* ---------- B. Hand step copy (always visible; re-applied after every re-render) ---------- */
  function applyHandCopy() {
    var handFs = handFieldset();
    if (!handFs) return;
    var swatches = $$('.label-swatch', handFs);
    var single = swatches.length === 1;
    var labelRow = handFs.querySelector('.form__label .flex.gap-2');
    if (labelRow && labelRow.firstChild && labelRow.firstChild.nodeType === 3 && labelRow.firstChild.textContent !== 'Worn on which hand? ') {
      labelRow.firstChild.textContent = 'Worn on which hand? ';
    }
    if (!handFs.querySelector('.cro-hand-help')) {
      var help = document.createElement('p');
      help.className = 'cro-hand-help';
      if (single) {
        var only = (swatches[0].getAttribute('title') || swatches[0].textContent || '').trim().toLowerCase();
        help.innerHTML = only.indexOf('right') === 0
          ? 'This pack ships <strong>right-hand gloves</strong>, worn by left-handed golfers.'
          : 'This pack ships <strong>left-hand gloves</strong>, worn by right-handed golfers.';
      } else {
        help.innerHTML = '<strong>Right-handed golfers wear a left-hand glove.</strong> Left-handed golfers wear a right-hand glove. Cadet = shorter fingers, wider palm.';
      }
      var labelWrap = handFs.querySelector('.form__label');
      if (labelWrap && labelWrap.parentNode) labelWrap.parentNode.insertBefore(help, labelWrap.nextSibling);
      else handFs.insertBefore(help, handFs.firstChild);
    }
    swatches.forEach(function (lab) {
      if (lab.querySelector('.cro-hand-sub')) return;
      var v = (lab.getAttribute('title') || lab.textContent || '').trim().toLowerCase();
      var sub = '';
      if (v === 'left') sub = 'for right-handed golfers';
      else if (v === 'right') sub = 'for left-handed golfers';
      else if (v.indexOf('cadet') > -1) sub = 'shorter fingers, wider palm';
      if (sub) { var s = document.createElement('span'); s.className = 'cro-hand-sub'; s.textContent = sub; lab.appendChild(s); }
    });
  }

  /* ---------- C. Sold out: let Klaviyo's back-in-stock button be the call to action ---------- */
  function applySoldOut() {
    if (!S.info) return;
    var btn = addButtons()[0];
    var kl = $('#klaviyo-bis-button-container', S.info) || $('#klaviyo-bis-button-container');
    var soldOut = !!(btn && btn.disabled);
    var hasKlaviyo = !!(kl && kl.querySelector('button, a'));
    S.info.classList.toggle('cro-soldout', soldOut && hasKlaviyo);
  }

  /* ---------- D. Ships-by date (PDP, cart drawer and cart page) ---------- */
  function shipsByHTML() {
    try {
      var ny = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
      var ship = new Date(ny);
      if (ny.getHours() >= 13) ship.setDate(ship.getDate() + 1);
      while (ship.getDay() === 0 || ship.getDay() === 6) ship.setDate(ship.getDate() + 1);
      var label = ship.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
      var sameDay = ship.toDateString() === ny.toDateString();
      return sameDay ? 'Order today and it ships <strong>today</strong>.' : 'Order today, ships by <strong>' + label + '</strong>.';
    } catch (err) { return 'Ships in 1 business day.'; }
  }
  function applyShipsBy(root) {
    var html = shipsByHTML();
    $$('[data-cro-shipby-text]', root || document).forEach(function (el) {
      if (el.getAttribute('data-cro-done')) return;
      el.setAttribute('data-cro-done', '1');
      el.innerHTML = html;
    });
  }
  // Rotate which review quote shows, so the cart strip is not identical on every visit.
  function applyCartReviews(root) {
    $$('[data-cro-cart-reviews]', root || document).forEach(function (box) {
      if (box.getAttribute('data-cro-done')) return;
      box.setAttribute('data-cro-done', '1');
      var items = $$('.cro-cart-reviews__item', box);
      if (items.length < 2) return;
      var pick = Math.floor(Math.random() * items.length);
      items.forEach(function (li, i) { li.hidden = i !== pick; });
    });
  }
  window.__croCartProof = function (root) { try { applyShipsBy(root); applyCartReviews(root); } catch (e) {} };

  /* ---------- F. Mobile: title, price and rating above the gallery ---------- */
  function applyMobileHead() {
    if (!window.matchMedia('(max-width: 767px)').matches) return;
    var gallery = $('.product__gallery-container');
    var titleEl = $('.product__title');
    if (!gallery || !titleEl || $('.cro-head')) return;
    var badge = $('.product__info .shopify-app-block .jdgm-widget');
    var badgeBlock = badge ? badge.closest('.shopify-app-block') : null;
    var head = document.createElement('div');
    head.className = 'cro-head';
    gallery.parentNode.insertBefore(head, gallery);
    // Clone rather than move, so the theme's own variant/price JS keeps its original nodes. Strip ids from the clone.
    var titleClone = titleEl.cloneNode(true);
    $$('[id]', titleClone).forEach(function (el) { el.removeAttribute('id'); });
    head.appendChild(titleClone); titleEl.classList.add('cro-moved');
    var row = document.createElement('div'); row.className = 'cro-head__row';
    if (badgeBlock) { var bc = badgeBlock.cloneNode(true); $$('[id]', bc).forEach(function (el) { el.removeAttribute('id'); }); bc.classList.add('cro-head__rating'); row.appendChild(bc); badgeBlock.classList.add('cro-moved'); }
    var priceEl = titleClone.querySelector('.price');
    if (priceEl) { priceEl.classList.add('cro-head__price'); row.appendChild(priceEl); }
    head.appendChild(row);
  }
  // Keep the cloned price in step with the live one (variant changes).
  function syncHeadPrice() {
    var clone = $('.cro-head__price'), live = $('.product__title.cro-moved .price');
    if (clone && live && clone.innerHTML !== live.innerHTML) clone.innerHTML = live.innerHTML;
  }

  /* ---------- H. Swipe arrows on the gallery and the thumbnail row (shown below 1024px via CSS) ---------- */
  function chevron(dir) {
    var d = dir === 'left' ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
  }
  function makeNav(extraClass, prevLabel, nextLabel) {
    var nav = document.createElement('div');
    nav.className = 'cro-swipe' + (extraClass ? ' ' + extraClass : '');
    nav.innerHTML = '<button type="button" class="cro-swipe__btn cro-swipe__btn--prev" aria-label="' + prevLabel + '">' + chevron('left') + '</button>' +
                    '<button type="button" class="cro-swipe__btn cro-swipe__btn--next" aria-label="' + nextLabel + '">' + chevron('right') + '</button>';
    return nav;
  }
  function bindNav(nav, scroller, step) {
    var prev = nav.querySelector('.cro-swipe__btn--prev'), next = nav.querySelector('.cro-swipe__btn--next'), t = null;
    function update() {
      if (!document.body.contains(scroller)) return;
      var max = scroller.scrollWidth - scroller.clientWidth;
      nav.classList.toggle('is-hidden', max < 6);
      prev.classList.toggle('is-off', scroller.scrollLeft <= 2);
      next.classList.toggle('is-off', scroller.scrollLeft >= max - 2);
    }
    nav.addEventListener('click', function (e) {
      var b = e.target.closest('.cro-swipe__btn'); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      step(b === next ? 1 : -1);
    });
    scroller.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(update);
      ro.observe(scroller);
      Array.prototype.forEach.call(scroller.children, function (c) { ro.observe(c); });
    }
    scroller.addEventListener('load', function () { clearTimeout(t); t = setTimeout(update, 60); }, true);
    window.addEventListener('load', update);
    update(); [600, 2000, 5000].forEach(function (ms) { setTimeout(update, ms); });
  }
  function applyArrows() {
    var slider = $('slider-element[id^="SliderGallery"]');
    if (slider && !slider.parentNode.querySelector('.cro-swipe--gallery') && slider.querySelectorAll('.product__media').length > 1) {
      var gnav = makeNav('cro-swipe--gallery', 'Previous photo', 'Next photo');
      slider.parentNode.appendChild(gnav);
      bindNav(gnav, slider, function (dir) {
        var first = slider.querySelector('.product__media');
        var off = slider.itemOffset || (first ? first.offsetWidth + 4 : slider.clientWidth);
        var page = Math.round(slider.scrollLeft / off);
        slider.scrollTo({ left: Math.max(0, (page + dir) * off), behavior: 'smooth' });
      });
    }
    var thumbs = $('.product__thumbnails');
    var tlist = thumbs ? thumbs.querySelector('.product__thumbnails-list') : null;
    if (thumbs && tlist && !thumbs.querySelector('.cro-swipe--thumbs') && tlist.children.length > 1) {
      var tnav = makeNav('cro-swipe--thumbs', 'Earlier photos', 'More photos');
      thumbs.appendChild(tnav);
      bindNav(tnav, tlist, function (dir) {
        tlist.scrollBy({ left: dir * Math.max(120, Math.round(tlist.clientWidth * 0.75)), behavior: 'smooth' });
      });
    }
  }

  /* ---------- E. Re-apply after the theme re-renders the variant picker ---------- */
  var reapplyTimer = null;
  function reapply() {
    try { applyHandCopy(); } catch (e) {}
    try { applySizeGate(); } catch (e) {}
    try { applySoldOut(); } catch (e) {}
    try { syncHeadPrice(); } catch (e) {}
  }
  function observe(info) {
    if (S.mo) { try { S.mo.disconnect(); } catch (e) {} }
    S.mo = new MutationObserver(function (muts) {
      var relevant = muts.some(function (m) { return m.addedNodes && m.addedNodes.length; });
      if (!relevant) return;
      clearTimeout(reapplyTimer);
      reapplyTimer = setTimeout(reapply, 40);
    });
    S.mo.observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }

  /* ---------- Init (runs at load and again whenever a fresh product-info appears) ---------- */
  function initPDP() {
    var info = $('product-info:not([data-cro-init])');
    if (!info) return;
    info.setAttribute('data-cro-init', '1');
    var form = info.querySelector('form.product-form[data-type="add-to-cart-form"]') || $('form.product-form[data-type="add-to-cart-form"]') || $('form[action*="/cart/add"]');
    if (!form) return;
    S.info = info; S.form = form; S.formId = form.getAttribute('id');
    S.originalLabels = []; S.pending = false;
    document.body.classList.remove('cro-size-pending');

    /* G. Style swatches first */
    try {
      var sgp = $('.style-group-picker'), vpEl = $('.variant-picker');
      if (sgp && vpEl && vpEl.parentNode) vpEl.parentNode.insertBefore(sgp, vpEl);
    } catch (e) {}

    /* A. gate */
    try {
      S.gateEnabled = !!sizeFieldset() && !/[?&]variant=\d+/.test(location.search);
      if (S.gateEnabled) {
        S.pending = true;
        applySizeGate();
        // Theme JS may re-check the radio when it boots; enforce again shortly after load.
        [300, 800, 1500, 2500, 4000].forEach(function (ms) { setTimeout(applySizeGate, ms); });
      }
    } catch (e) {}

    /* Accordions start closed, Product Details included, so the buy box is not pushed down. */
    try {
      $$('details[open]', info).forEach(function (d) {
        if (d.getAttribute('data-cro-closed')) return;
        d.setAttribute('data-cro-closed', '1');
        d.removeAttribute('open');
      });
    } catch (e) {}

    try { applyHandCopy(); } catch (e) {}
    try { applySoldOut(); [800, 2500, 5000].forEach(function (ms) { setTimeout(applySoldOut, ms); }); } catch (e) {}
    try { applyShipsBy(); } catch (e) {}
    try { applyMobileHead(); } catch (e) {}
    try { applyArrows(); } catch (e) {}
    try { observe(info); } catch (e) {}
  }

  initPDP();
  // The theme's Style picker swaps the whole product section (dispatches shopify:section:load); popstate does the same without the event.
  document.addEventListener('shopify:section:load', function () { setTimeout(initPDP, 60); });
  window.addEventListener('popstate', function () { setTimeout(initPDP, 400); });
  try {
    new MutationObserver(function () {
      if ($('product-info:not([data-cro-init])')) { clearTimeout(reapplyTimer); setTimeout(initPDP, 60); }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
  var rsz = null;
  window.addEventListener('resize', function () { clearTimeout(rsz); rsz = setTimeout(function () { try { applyMobileHead(); } catch (e) {} }, 150); });
})();


/* ============================================================
   Cart drawer: "Complete the set" rows (Shift 2, D4; rebuilt Sept 3 evening).
   Each row carries a JSON blob (products in the style group, their options and variants).
   The row shows one <select> per product option plus a Colour select when the style group has siblings.
   Add goes through /cart/add.js and the drawer is re-rendered from the section rendering API, staying open.
   ============================================================ */
(function () {
  'use strict';
  function money(cents) {
    try {
      var fmt = (window.theme && theme.moneyFormat) || (window.Shopify && Shopify.money_format) || '${{amount_no_decimals}}';
      var v = cents / 100;
      var s = /no_decimals/.test(fmt) ? String(Math.round(v)) : v.toFixed(2);
      return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]*>/g, '');
    } catch (e) { return '$' + Math.round(cents / 100); }
  }
  function rerender(sectionsHtml) {
    try {
      var html = sectionsHtml && sectionsHtml['cart-drawer'];
      var drawer = document.querySelector('cart-drawer');
      if (!html || !drawer) return false;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('cart-drawer');
      if (!fresh) return false;
      drawer.innerHTML = fresh.innerHTML;
      drawer.querySelectorAll('.opacity-0.invisible').forEach(function (el) { el.classList.remove('opacity-0', 'invisible'); });
      initRows(drawer);
      if (window.__croCartProof) window.__croCartProof(drawer);
      return true;
    } catch (e) { return false; }
  }
  function updateCount(count) {
    document.querySelectorAll('cart-count, .cart-count, [data-cart-count]').forEach(function (el) {
      if (el.tagName === 'CART-COUNT') { el.textContent = count; el.setAttribute('count', count); } else { el.textContent = count; }
    });
  }

  /* ----- row state ----- */
  function rowData(row) {
    if (row.__cro) return row.__cro;
    var s = row.querySelector('script.cro-xsell__data');
    if (!s) return null;
    try { row.__cro = JSON.parse(s.textContent); } catch (e) { return null; }
    return row.__cro;
  }
  function currentProduct(row, data) {
    var sel = row.querySelector('select[data-cro-colour]');
    var h = sel ? sel.value : (data.products[0] && data.products[0].handle);
    for (var i = 0; i < data.products.length; i++) if (data.products[i].handle === h) return data.products[i];
    return data.products[0];
  }
  function selectedValues(row, product) {
    return product.options.map(function (name, i) {
      var sel = row.querySelector('select[data-cro-opt="' + i + '"]');
      return sel ? sel.value : null;
    });
  }
  function findVariant(product, values) {
    var exact = null, fallback = null;
    product.variants.forEach(function (v) {
      var match = true;
      for (var i = 0; i < values.length; i++) if (values[i] !== null && v.o[i] !== values[i]) match = false;
      if (match && !exact) exact = v;
    });
    return exact || fallback;
  }
  // Rebuild the option selects for a product, keeping the previously chosen values when they exist.
  function buildOptionSelects(row, product, prefer) {
    var wrap = row.querySelector('.cro-xsell__opts');
    if (!wrap) return;
    var chosen = prefer || [];
    wrap.innerHTML = '';
    product.options.forEach(function (name, i) {
      var values = [];
      product.variants.forEach(function (v) { if (values.indexOf(v.o[i]) === -1) values.push(v.o[i]); });
      if (values.length < 2 && product.options.length === 1 && /title/i.test(name)) return;
      var sel = document.createElement('select');
      sel.className = 'cro-xsell__sel';
      sel.setAttribute('data-cro-opt', i);
      sel.setAttribute('aria-label', name);
      values.forEach(function (val) {
        var o = document.createElement('option'); o.value = val; o.textContent = val;
        // Grey out values with no available variant given the other current choices (approximation: any availability).
        var anyAvail = product.variants.some(function (v) { return v.o[i] === val && v.a; });
        if (!anyAvail) { o.disabled = true; o.textContent = val + ' (sold out)'; }
        sel.appendChild(o);
      });
      var want = chosen[i];
      if (want !== undefined && want !== null && values.indexOf(want) > -1 && !sel.querySelector('option[value="' + CSS.escape(want) + '"]').disabled) sel.value = want;
      else { var firstOk = Array.prototype.find.call(sel.options, function (o) { return !o.disabled; }); if (firstOk) sel.value = firstOk.value; }
      wrap.appendChild(sel);
    });
  }
  function refreshRow(row) {
    var data = rowData(row); if (!data) return;
    var product = currentProduct(row, data);
    var values = selectedValues(row, product);
    var v = findVariant(product, values);
    var idEl = row.querySelector('input[name="id"]');
    var btn = row.querySelector('.cro-xsell__add');
    var img = row.querySelector('.cro-xsell__img img');
    var link = row.querySelector('.cro-xsell__img');
    var price = row.querySelector('[data-cro-price]');
    var title = row.querySelector('[data-cro-title]');
    if (title && data.products.length > 1) title.textContent = (product.family || '') + (product.short ? ' · ' + product.short : '');
    if (link) link.setAttribute('href', product.url + (v ? '?variant=' + v.id : ''));
    if (img) { var src = (v && v.img) || product.img; if (src && img.getAttribute('src') !== src) { img.removeAttribute('srcset'); img.setAttribute('src', src); } }
    if (v) {
      if (idEl) idEl.value = v.id;
      if (price) price.textContent = v.pm || money(v.p);
      if (btn) { btn.disabled = !v.a; btn.textContent = v.a ? '+ Add' : 'Sold out'; btn.classList.remove('loading'); }
    } else {
      if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
    }
  }
  function initRows(root) {
    (root || document).querySelectorAll('.cro-xsell__row[data-cro-row]').forEach(function (row) {
      if (row.getAttribute('data-cro-ready')) return;
      row.setAttribute('data-cro-ready', '1');
      var data = rowData(row); if (!data) return;
      var product = currentProduct(row, data);
      buildOptionSelects(row, product, data.prefer || []);
      refreshRow(row);
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var row = t.closest('.cro-xsell__row[data-cro-row]'); if (!row) return;
    var data = rowData(row); if (!data) return;
    if (t.hasAttribute('data-cro-colour')) {
      // Product switch: rebuild the option selects, trying to keep the same choices (gender / size / hand).
      var prevProduct = data.__lastProduct || currentProduct(row, data);
      var prevValues = selectedValues(row, prevProduct);
      var product = currentProduct(row, data);
      var prefer = product.options.map(function (name) { var j = prevProduct.options.indexOf(name); return j > -1 ? prevValues[j] : null; });
      buildOptionSelects(row, product, prefer);
    }
    data.__lastProduct = currentProduct(row, data);
    refreshRow(row);
  });

  /* ----- add ----- */
  function onAdd(e) {
    var btn = e.target.closest && e.target.closest('.cro-xsell__add');
    if (!btn) return;
    var form = btn.closest('.cro-xsell__form');
    if (!form) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.disabled) return;
    var idEl = form.querySelector('[name="id"]');
    if (!idEl || !idEl.value) return;
    btn.disabled = true; btn.classList.add('loading'); btn.textContent = 'Adding';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(idEl.value, 10), quantity: 1 }], sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data.status && data.status >= 400) throw new Error(data.description || 'Could not add');
      var ok = rerender(data.sections);
      if (data.item_count !== undefined) updateCount(data.item_count);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('theme:cart:update'));
      if (!ok) { fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); }); btn.textContent = 'Added'; }
    }).catch(function () {
      btn.disabled = false; btn.classList.remove('loading'); btn.textContent = 'Try again';
    });
  }
  document.addEventListener('click', onAdd, true);
  document.addEventListener('submit', function (e) { if (e.target.classList && e.target.classList.contains('cro-xsell__form')) { e.preventDefault(); } }, true);

  /* ---------- Optimistic cart feedback (Sept 14) ----------
     A cart action on this store fires one write plus eight app re-reads, so the drawer sits
     unchanged for 1.5 to 2 seconds after a tap. Nothing here changes what the server does: the
     row collapses and the header count moves the instant the shopper acts, and the theme's own
     re-render (or the watchdog below) is still the source of truth a second later.
     Remove: delete this block and the .cro-removing / .cro-busy rules in assets/cro.css. */
  function croRow(el) {
    return el && el.closest ? el.closest('.horizontal-product, [id^="CartDrawer-Item-"], [id^="CartItem-"]') : null;
  }
  function croCountEls() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-count, [data-cart-count], .cart-count, .header__cart-count, [data-cro-count]'));
  }
  function croBumpCount(delta) {
    croCountEls().forEach(function (el) {
      var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
      if (isNaN(n)) return;
      var next = Math.max(0, n + delta);
      el.textContent = String(next);
      // The theme's <cart-count> announces itself to screen readers via aria-label, keep it in step.
      if (el.hasAttribute && el.hasAttribute('aria-label')) {
        el.setAttribute('aria-label', next + (next === 1 ? ' item' : ' items'));
      }
    });
  }
  // If the theme has not re-rendered the drawer within a few seconds, put the row back rather
  // than leaving a line the shopper thinks is gone but is still in their cart.
  function croWatchdog(row, qty) {
    setTimeout(function () {
      if (!row || !row.isConnected) return;
      row.classList.remove('cro-removing');
      row.style.maxHeight = '';
      croBumpCount(qty);
    }, 7000);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // Remove: collapse the row now, let the theme's request run untouched.
    var rem = t.closest('[is="cart-remove-button"], a[href*="/cart/change"]');
    if (rem && croRow(rem)) {
      var row = croRow(rem);
      if (row.classList.contains('cro-removing')) return;
      var qtyEl = row.querySelector('input[name="updates[]"]');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      row.style.maxHeight = row.offsetHeight + 'px';
      row.classList.add('cro-removing');
      requestAnimationFrame(function () { row.style.maxHeight = '0px'; });
      croBumpCount(-qty);
      croWatchdog(row, qty);
      return;
    }

    // Quantity steppers: move the visible number and the header count immediately.
    var step = t.closest('quantity-input button, .quantity button, [name="minus"], [name="plus"]');
    if (step && croRow(step)) {
      var row2 = croRow(step);
      var input = row2.querySelector('input[name="updates[]"]');
      if (!input) return;
      var cur = parseInt(input.value, 10) || 1;
      var down = /minus/i.test(step.getAttribute('name') || '') || /^-|−|minus/i.test((step.textContent || '').trim());
      var next = down ? cur - 1 : cur + 1;
      if (next < 0) return;
      row2.classList.add('cro-busy');
      croBumpCount(next - cur);
      setTimeout(function () { if (row2 && row2.isConnected) row2.classList.remove('cro-busy'); }, 7000);
    }
  }, true);

  // Rows rendered by the theme's own drawer refreshes (after a normal add to cart) need wiring too.
  initRows(document);
  if (window.__croCartProof) window.__croCartProof(document);
  try {
    new MutationObserver(function () { initRows(document); if (window.__croCartProof) window.__croCartProof(document); }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();

/* ---------- Carousel arrows as side overlays (Sept 14) ----------
   The theme prints prev/next inside .title-wrapper, so every slider section spends a full button
   height of vertical space on its heading row before the products even start. The buttons are
   moved onto the slider itself, one on each edge, vertically centred. Nothing about how they work
   changes: they still drive their slider through aria-controls, and they stay desktop only.
   Remove: delete this block and section 13 of assets/cro.css. */
(function () {
  function directSlider(host) {
    for (var i = 0; i < host.children.length; i++) {
      var tag = host.children[i].tagName;
      if (tag === 'SLIDER-ELEMENT' || tag === 'CAROUSEL-ELEMENT') return host.children[i];
    }
    return null;
  }
  function place(ind, slider) {
    if (!ind.isConnected || !slider.isConnected) return;
    ind.style.top = (slider.offsetTop + slider.offsetHeight / 2) + 'px';
    ind.style.left = slider.offsetLeft + 'px';
    ind.style.width = slider.offsetWidth + 'px';
  }
  function watch(ind, slider) {
    var run = function () { place(ind, slider); };
    window.addEventListener('resize', run);
    window.addEventListener('load', run);
    try { new ResizeObserver(run).observe(slider); } catch (e) {}
    setTimeout(run, 300);
    setTimeout(run, 1200);
  }
  function boot(root) {
    var inds = (root || document).querySelectorAll('.title-wrapper .indicators');
    for (var i = 0; i < inds.length; i++) {
      var ind = inds[i];
      if (ind.getAttribute('data-cro-arrows')) continue;
      if (ind.querySelectorAll('button').length < 2) continue;
      var tw = ind.closest('.title-wrapper');
      var host = tw && tw.parentElement;
      if (!host) continue;
      var slider = directSlider(host);
      if (!slider) continue;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      ind.setAttribute('data-cro-arrows', '1');
      ind.classList.add('cro-arrows');
      host.appendChild(ind);
      place(ind, slider);
      watch(ind, slider);
    }
  }
  function safeBoot() { try { boot(document); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', safeBoot);
  else safeBoot();
  document.addEventListener('shopify:section:load', safeBoot);
})();
